module.exports = __webpack_public_path__ + "img/google.804967bb.svg";